/** Enquiries-board deals with a tender date, for the "Coming up" list. The caller passes a workspace only for
 *  people holding the Enquiries board grant. Any failure just means no rows. Refetches when the date changes so
 *  a tender date arriving overnight appears on a dashboard left open. */

import { useEffect, useMemo, useState } from 'react';
import type { WorkspaceDeal } from '../pipeline/types';
import { useBackgroundRead } from '../../hooks/useBackgroundRead';
import { enquiryDealsRead, localDayKey } from './homeComingUpReads';

const DAY_CHECK_MS = 5 * 60_000;
const NONE: readonly WorkspaceDeal[] = [];

export function useEnquiryDeals(workspaceId: string | undefined): readonly WorkspaceDeal[] {
  const [dayKey, setDayKey] = useState(localDayKey);

  useEffect(() => {
    const id = window.setInterval(() => setDayKey(localDayKey()), DAY_CHECK_MS);
    return () => window.clearInterval(id);
  }, []);

  const read = useMemo(() => (workspaceId ? enquiryDealsRead(workspaceId) : null), [workspaceId]);
  return useBackgroundRead(workspaceId, read, { refreshKey: dayKey }) ?? NONE;
}
